import React from 'react';

const StateDropdown = ({ value, onChange, name, disabled = false, showExitState = false }) => {
  const states = [
    'Neuf',
    'Très bon',
    'Bon',
    'Assez bon',
    'Passable',
    'Mauvais',
    'Très mauvais'
  ];

  // Determine if this field should be enabled based on the showExitState prop
  // For "entrée" type, only entry state fields are enabled
  // For "sortie" type, both entry and exit state fields are enabled
  const isFieldDisabled = disabled || (showExitState && name && name.includes('entryState'));

  return (
    <select
      value={value || ''}
      onChange={onChange}
      name={name}
      disabled={isFieldDisabled}
      className={`block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${
        isFieldDisabled ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''
      }`}
    >
      <option value="">Sélectionner...</option>
      {states.map(state => (
        <option key={state} value={state}>
          {state}
        </option>
      ))}
    </select>
  );
};

export default StateDropdown;
